import React from 'react';
import clsx from 'clsx';
import { Dialog, DialogActions, DialogContent } from '@mui/material';
import { Button, Typography } from "@curves/ui-base";
import GradientColorHeader from '@icoach/components/dialog/GradientColorHeader';

const ConfirmHealthDeclarationContinueDialog = (props) => {
    const {
        className,
        nextDocTitle,
        open,
        handleClose,
        handleClickYes: handleClickYesFn,
        handleClickNo: handleClickNoFn,
    } = props;
    const handleCloseEvent = (e) => {
        if (typeof handleClose === 'function') handleClose(e);
    };

    const handleClickYes = (e) => {
        if (typeof handleClickYesFn === 'function') handleClickYesFn();
    };

    const handleClickNo = (e) => {
        if (typeof handleClickNoFn === 'function') handleClickNoFn();
    };
    return (
        <Dialog open={open} fullWidth className={clsx('simple-content', 'dialog', className)}>
            <GradientColorHeader onClose={handleCloseEvent}>重要提醒</GradientColorHeader>
            <DialogContent>
                <Typography paragraph>{`${nextDocTitle}？`} </Typography>
            </DialogContent>
            <DialogActions>
                <Button color="error" variant="contained" onClick={handleClickNo}>
                    否，保留
                </Button>
                <Button color="success" variant="contained" onClick={handleClickYes}>
                    是，前往
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmHealthDeclarationContinueDialog; 